import {
    blockScreen,
    getActiveTokens,
    unblockScreen,
    getKeyInfo,
    signXml,
    signXmls,
    createCAdESFromFile,
    createCAdESFromBase64,
    applyCAdEST,
    createCAdESFromBase64Hash,
    showFileChooser,
    changeLocale,
    createCMSSignatureFromBase64,
    createCMSSignatureFromFile
} from './ncalayer.lib';

export const getActiveTokensCall = function () {
    blockScreen();
    getActiveTokens('getActiveTokensBack');
};

export const getActiveTokensBack = function (result) {
    unblockScreen();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const listOfTokens = result.responseObject;
        $('#storageSelect').empty();
        $('#storageSelect').append('<option value="PKCS12">PKCS12</option>');
        for (let i = 0; i < listOfTokens.length; i++) {
            $('#storageSelect').append('<option value="' + listOfTokens[i] + '">' + listOfTokens[i] + '</option>');
        }
    }
};

export const getKeyInfoCall = function () {
    blockScreen();
    const selectedStorage = $('#storageSelect').val();
    getKeyInfo(selectedStorage, 'getKeyInfoBack');
};

export const getKeyInfoBack = function (result) {
    unblockScreen();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const res = result.responseObject;

        const alias = res.alias;
        $('#alias').val(alias);

        const keyId = res.keyId;
        $('#keyId').val(keyId);

        const algorithm = res.algorithm;
        $('#algorithm').val(algorithm);

        const subjectCn = res.subjectCn;
        $('#subjectCn').val(subjectCn);

        const subjectDn = res.subjectDn;
        $('#subjectDn').val(subjectDn);

        const issuerCn = res.issuerCn;
        $('#issuerCn').val(issuerCn);

        const issuerDn = res.issuerDn;
        $('#issuerDn').val(issuerDn);

        const serialNumber = res.serialNumber;
        $('#serialNumber').val(serialNumber);

        let dateString = res.certNotAfter;
        let date = new Date(Number(dateString));
        $('#notafter').val(date.toLocaleString());

        dateString = res.certNotBefore;
        date = new Date(Number(dateString));
        $('#notbefore').val(date.toLocaleString());

        const authorityKeyIdentifier = res.authorityKeyIdentifier;
        $('#authorityKeyIdentifier').val(authorityKeyIdentifier);

        const pem = res.pem;
        $('#pem').val(pem);
    }
};

export const signXmlCall = function (xmlToSign, keyType, selectedStorage, callback) {
    blockScreen();
    signXml(selectedStorage, keyType, xmlToSign, callback);
};

export const signXmlBack = function (result) {
    unblockScreen();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        $('#signedXml').val(result.responseObject);
        $('#checkXml').click();
    }
};

export const signXmlsCall = function () {
    const xmlToSign1 = $('#xmlToSign1').val();
    const xmlToSign2 = $('#xmlToSign2').val();
    const xmlsToSign = [xmlToSign1, xmlToSign2];
    const selectedStorage = $('#storageSelect').val();
    blockScreen();
    signXmls(selectedStorage, 'SIGNATURE', xmlsToSign, 'signXmlsBack');
};

export const signXmlsBack = function (result) {
    unblockScreen();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const res = result.responseObject;
        $('#signedXml1').val(res[0]);
        $('#signedXml2').val(res[1]);
    }
};

export const createCAdESFromFileCall = function () {
    const selectedStorage = $('#storageSelect').val();
    const flag = $('#flag').is(':checked');
    const filePath = $('#filePath').val();
    if (filePath !== null && filePath !== '') {
        blockScreen();
        createCAdESFromFile(selectedStorage, 'SIGNATURE', filePath, flag, 'createCAdESFromFileBack');
    } else {
        alert('Не выбран файл для подписи!');
    }
};

export const createCAdESFromFileBack = function (result) {
    unblockScreen();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const res = result.responseObject;
        $('#createdCMS').val(res);
    }
};

export const createCAdESFromBase64Call = function () {
    const selectedStorage = $('#storageSelect').val();
    const flag = $('#flagForBase64').is(':checked');
    const base64ToSign = $('#base64ToSign').val();
    if (base64ToSign !== null && base64ToSign !== '') {
        $.blockUI();
        createCAdESFromBase64(selectedStorage, 'SIGNATURE', base64ToSign, flag, 'createCAdESFromBase64Back');
    } else {
        alert('Нет данных для подписи!');
    }
};

export const createCAdESFromBase64Back = function (result) {
    $.unblockUI();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const res = result.responseObject;
        $('#createdCMSforBase64').val(res);
    }
};

export const createCAdESFromBase64HashCall = function () {
    const selectedStorage = $('#storageSelect').val();
    const base64ToSign = $('#base64HashToSign').val();
    if (base64ToSign !== null && base64ToSign !== '') {
        $.blockUI();
        createCAdESFromBase64Hash(selectedStorage, 'SIGNATURE', base64ToSign, 'createCAdESFromBase64HashBack');
    } else {
        alert('Нет данных для подписи!');
    }
};

export const createCAdESFromBase64HashBack = function (result) {
    $.unblockUI();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const res = result.responseObject;
        $('#createdCMSforBase64Hash').val(res);
    }
};

export const applyCAdESTCall = function () {
    const selectedStorage = $('#storageSelect').val();
    const cmsForTS = $('#CMSForTS').val();
    if (cmsForTS !== null && cmsForTS !== '') {
        $.blockUI();
        applyCAdEST(selectedStorage, 'SIGNATURE', cmsForTS, 'applyCAdESTBack');
    } else {
        alert('Нет данных для подписи!');
    }
};

export const applyCAdESTBack = function (result) {
    $.unblockUI();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const res = result.responseObject;
        $('#createdCMSWithAppliedTS').val(res);
    }
};

export const showFileChooserCall = function () {
    blockScreen();
    showFileChooser('ALL', '', 'showFileChooserBack');
};

export const showFileChooserBack = function (result) {
    unblockScreen();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const res = result.responseObject;
        $('#filePath').val(res);
    }
};

export const showFileChooserForTSCall = function () {
    blockScreen();
    showFileChooser('ALL', '', 'showFileChooserForTSBack');
};

export const showFileChooserForTSBack = function (result) {
    unblockScreen();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const res = result.responseObject;
        $('#filePathWithTS').val(res);
    }
};

export const changeLocaleCall = function () {
    const selectedLocale = $('#localeSelect').val();
    changeLocale(selectedLocale);
};

export const createCMSSignatureFromFileCall = function () {
    const selectedStorage = $('#storageSelect').val();
    const flag = $('#flagForCMSWithTS').is(':checked');
    const filePath = $('#filePathWithTS').val();
    if (filePath !== null && filePath !== '') {
        blockScreen();
        createCMSSignatureFromFile(selectedStorage, 'SIGNATURE', filePath, flag, 'createCMSSignatureFromFileBack');
    } else {
        alert('Не выбран файл для подписи!');
    }
};

export const createCMSSignatureFromFileBack = function (result) {
    unblockScreen();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const res = result.responseObject;
        $('#createdCMSWithTS').val(res);
    }
};

export const createCMSSignatureFromBase64Call = function () {
    const selectedStorage = $('#storageSelect').val();
    const flag = $('#flagForBase64WithTS').is(':checked');
    const base64ToSign = $('#base64ToSignWithTS').val();
    if (base64ToSign !== null && base64ToSign !== '') {
        $.blockUI();
        createCMSSignatureFromBase64(selectedStorage, 'SIGNATURE', base64ToSign, flag, 'createCMSSignatureFromBase64Back');
    } else {
        alert('Нет данных для подписи!');
    }
};

export const createCMSSignatureFromBase64Back = function (result) {
    $.unblockUI();
    if (result.code === '500') {
        alert(result.message);
    } else if (result.code === '200') {
        const res = result.responseObject;
        $('#createdCMSforBase64WithTS').val(res);
    }
};
